module.exports = __webpack_public_path__ + "static/img/mdm_register1.0c79271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/mdm_register1.jpg
// module id = gfph
// module chunks = 60